






































































import Modal from '../Base.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

import jQuery from 'jquery';
@Component({
	name: 'IncludeClaimantWarningMessage',
	components: {
		Modal,
	},
})
export default class IncludeClaimantWarningMessage extends Vue {
	@Prop() private claimantName: string;
	private agree() {
		this.$emit('update:claimantName', 'true');
		jQuery(`#claimantWarningMessage`).modal('hide');
	}
	private doNotAgree() {
		this.$emit('update:claimantName', 'false');
		jQuery(`#claimantWarningMessage`).modal('hide');
	}
}
